import React, {useEffect, useState,useRef} from "react";


import get from "lodash/get";

import { connect } from "react-redux";
import { bindActionCreators,compose } from "redux";
import  {loginService} from '@app/common/services/loginservice'
import {
    loadAccess,
    loadLevel,
    setLoading,
    loadUser,
} from "@app/common/store/action";
import {Link, withRouter} from "react-router-dom";

import style from './confirmpasswordform.module.css'
import Grid from "@material-ui/core/Grid";

import MFACodeContainer from "../../../components/mfacodecontainer/mfacodecontainer";

import TwoButtonContainer from "../../../components/twobuttoncontainer/twobuttoncontainer";


import {FORGOT_PASSWORD_ROUTE, LOGIN_ROUTE} from "../../../constants/routeconstants";
import {FORGOT_CONFIRM_PASSWORD_ROUTE} from "../../../constants/routeconstants";
import CustomButton from "../../../components/custombutton/custombutton";
import {
    CODE_LENGTH, CONFIRM_RESET_OTP_AFTER, CONFIRM_RESET_OTP_CLICK,
    CONFIRM_RESET_OTP_RETRY,
    NEXT,
    OTP_EMPTY_ERR,
    RESET_CONFIRM_OTP_TEXT
} from "../../../constants/appconstants";
import {MFA_OTP_WRONG_ERR} from "@app/common/constants/constants";
import {Tooltip} from "@material-ui/core";
import Timer from "../../../components/timer/timer";

function ConfirmOTPResetPasswordForm(props){
    const [errorText,setErrorText] = useState("");
    const [otpErrorStatus,setOTPErrorStatus] = useState(false);
    const [secretCode,setSecretCode]  = useState(undefined);
    const [code,setCode]  = useState("");
    const [mfaSession,setMFASession]  = useState("");
    const [startTime,setStartTimer]  = useState(false)
    const [currentTimer,SetCurrentTimer]  = useState(0)
    const timerRef = useRef(null);

    useEffect (()=>{
      const error = get(props, "location.state.error",false);
      if(error){
          setOTPErrorStatus(true)
          setErrorText(MFA_OTP_WRONG_ERR)
      }else{
          setStartTimer(true)
      }
  },[])

    const onSubmitHandler =  (e) => {
        e.preventDefault()
        console.log("code",code.length)
        console.log("")
        console.log("code.length <=",code.length <= CODE_LENGTH)
        if(code === "" || code.length < CODE_LENGTH){
            setCode("")
            setOTPErrorStatus(true)
            setErrorText(OTP_EMPTY_ERR)
            return
        }
        const userName = get(props, "location.state.userName");

        console.log("userName",userName)
        props.history.push({
            pathname:FORGOT_CONFIRM_PASSWORD_ROUTE,
            state:{
                otpCode:code,
                userName:userName
            }
        })
    };

    const onCloseRequestHandler = ()=>{
        console.log("closse")
        props.history.push(LOGIN_ROUTE)
    }
    const setMFACodeHandler = (code)=>{
        console.log("code",code)
        setCode(code)
    }
    const handleSetTimer = (timer)=>{
        SetCurrentTimer(timer)
    }
    console.log("userName",props.user.userName)
    return (
        <form onSubmit={onSubmitHandler}>
            <Grid container direction={"column"} justify={"center"} alignItems={"center"} className={style.confirm_reset_otp_form_container}>
                <Grid item className={style.confirm_reset_otp_form_desc_text} >
                    {RESET_CONFIRM_OTP_TEXT}
                </Grid>
                <Grid item className={style.confirm_reset_otp_form_code_container} style={{paddingBottom:"0px"}}>
                    <MFACodeContainer setCodeRequestHandler={setMFACodeHandler} code={code} errorText={errorText} errorStatus={otpErrorStatus}/>
                </Grid>
                <Grid item className={style.confirm_reset_otp_form_code_container}>
                    <CustomButton title= {NEXT}/>
                </Grid>
                <Timer initialTimerText={"03:00"} timerInSeconds={180} ref={timerRef} setTimer={handleSetTimer}/>
                <Grid item className={style.confirm_reset_otp_form_bottom_text}>
                    {CONFIRM_RESET_OTP_RETRY} {startTime && currentTimer !== "00:00"?
                    <Tooltip title={CONFIRM_RESET_OTP_CLICK + currentTimer}><span className={style.confirm_reset_otp_resend_disabled}>Resend</span></Tooltip>:<Link to={FORGOT_PASSWORD_ROUTE}>Resend</Link>}
                </Grid>
            </Grid>
        </form>

    );
}

const mapStateToProps = (state, ownProps) => ({
    access: state.access,
    session:state.session,
    user:state.user,
});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            { loadAccess, loadLevel, setLoading, loadUser },
            dispatch
        ),
    };
}

export default compose(connect(mapStateToProps, mapDispatchToProps),withRouter)(ConfirmOTPResetPasswordForm);



